import React from "react";
import PayoutMakerDashboard from "../../components/PayoutMakerDashBoard/PayoutMakerDashboard";

const PayoutMakerDashboardContainers = () => {
  return <PayoutMakerDashboard />;
};

export default PayoutMakerDashboardContainers;
